import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle as MuiDialogTitle,
  IconButton,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import classNames from "classnames";
import PropTypes from "prop-types";
import React from "react";

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  "& .MuiDialogTitle-root": {
    position: "relative",
  },
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: "1px",
  color: theme.palette.grey[500],
  "&:hover": {
    color: theme.palette.secondary.main,
  },
}));

const StyledDialog = styled(Dialog)(({ theme, bigHeight }) => ({
  "& .MuiDialog-paper": {
    minHeight: bigHeight ? "90vh" : "auto",
    maxHeight: bigHeight ? "95vh" : "auto",
  },
}));

const CustomDialogTitle = ({ children, noWrap, onClose, ...other }) => {
  return (
    <StyledDialogTitle disableTypography {...other}>
      {onClose ? (
        <CloseButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      ) : null}
      {children}
    </StyledDialogTitle>
  );
};

function RenderModal(props) {
  const {
    handleClose,
    size,
    title,
    open,
    bigHeight,
    noWrap,
    forcedZindex,
    removeDropClick,
    contentStyle,
  } = props;

  let zindexStyle = {};

  forcedZindex && (zindexStyle = { zIndex: 1300 });

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      maxWidth={size}
      fullWidth
      bigHeight={bigHeight}
      disableBackdropClick={removeDropClick}
      style={{ zindexStyle }}
    >
      <CustomDialogTitle
        id="customized-dialog-title"
        onClose={handleClose}
        noWrap={noWrap}
      >
        {title}
      </CustomDialogTitle>

      <DialogContent style={contentStyle}>{props.children}</DialogContent>
    </StyledDialog>
  );
}

RenderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  forcedZindex: PropTypes.bool,
  bigHeight: PropTypes.bool,
  size: PropTypes.string,
  handleClose: PropTypes.func,
  noWrap: PropTypes.bool,
  title: PropTypes.string,
  contentStyle: PropTypes.object,
  children: PropTypes.node,
};

export default RenderModal;
